module.exports = __webpack_public_path__ + "img/chongci_ps_27.a20ed5d8.jpg";